import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateLanguage } from '../../modules/supportedLanguage';
import WindowEventListener from '../WindowEventListener';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
};

class SetLanguageId extends Component {
  receiveMessage = ({ origin, data: { type, payload } }) => {
    const { dispatch } = this.props;
    const matchURL = /https?:\/\/+([a-z])*\.*([a-z])*\.*(isf)+\.*[io]*(com)*/;

    if (type === 'SET_LANGUAGE_ID_REQUEST') {
      if (origin.match(matchURL) && payload) {
        dispatch(updateLanguage(payload));
      }
    }
  }

  render() {
    return <WindowEventListener event="message" onEvent={this.receiveMessage} />;
  }
}

SetLanguageId.propTypes = propTypes;

export default connect()(SetLanguageId);
